import { NgModule, Input,OnInit } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { AuthGuard } from "./auth.guard"

import { FullLayoutComponent } from "./layouts/full/full-layout.component";
import { ContentLayoutComponent } from "./layouts/content/content-layout.component";
import { FrameComponent } from './layouts/frame/frame.component';
import { Full_ROUTES } from "./shared/routes/full-layout.routes";
import { CONTENT_ROUTES } from "./shared/routes/content-layout.routes";

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'mapa',
    pathMatch: 'full',
    canActivate: [AuthGuard],
    canActivateChild : [AuthGuard]
  },
  { path: '', 
    component: FullLayoutComponent, 
    data: { title: 'full Views' }, 
    children: Full_ROUTES, 
    canActivate: [AuthGuard],
    canActivateChild : [AuthGuard]
  },
  { path: '', 
    component: ContentLayoutComponent, 
    data: { title: 'content Views' }, 
    children: CONTENT_ROUTES, 
    canActivate: [AuthGuard],
    canActivateChild : [AuthGuard]
  },
  
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { enableTracing: false, useHash: true })],
  exports: [RouterModule]
})

export class AppRoutingModule  implements OnInit{

  @Input() objetoAchado

  ngOnInit(){
    console.log('app route', this.objetoAchado)
  }

}

export const routingComponents = [
    FullLayoutComponent,
    ContentLayoutComponent,
    FrameComponent]



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts